import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronUpLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M9.55792 7.05806C9.802 6.81398 10.1977 6.81398 10.4418 7.05806L16.2751 12.8914C16.5192 13.1355 16.5192 13.5312 16.2751 13.7752C16.031 14.0193 15.6353 14.0193 15.3913 13.7752L9.99984 8.38391L4.60844 13.7752C4.36437 14.0193 3.96864 14.0193 3.72456 13.7752C3.48049 13.5312 3.48049 13.1355 3.72456 12.8914L9.55792 7.05806Z",
		fill: "currentColor"
	})
});
export default SvgChevronUpLine;
